







































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'
import Modal from './Modal.vue'
import FilterBarDownload from '@/components/FilterBarDownload.vue'
import DateRangeInput from '@/components//DateRangeInput.vue'
import { getGeneralNPSReport, getGeneralNPSReportAsync } from '@/api/teamscoreboard'
import { IIndustry } from '@/entities'
import moment from 'moment'

@Component<GeneralNPSReportDownload>({
    components: { FilterBarDownload, DateRangeInput }
})
export default class GeneralNPSReportDownload extends Vue {
    @Getter public industries
    @Getter public appBaseUrl
    @Getter public company

    @Action public loadBenchmarkIndustriesList
    @Action public loadCompany
    @Action public setIndustry

    public defaultIndustry: IIndustry = {
        id: 0,
        industry: 'Please select industry',
        has_sufficient_data: true
    }
    public industriesLoaded = false
    public industry: string = this.defaultIndustry.industry
    public toDate: Date = new Date()
    public fromDate: Date = moment(new Date()).subtract(1, 'month').toDate() // default to 1 month before

    public mounted() {
        this.loadData()
    }

    public async loadData() {
        await this.loadCompany()
        if (!this.isInvalidIndustry) {
            this.industry = this.selectedIndustry;
        }
    }

    // apply extra style to date-range-input
    public get dateRangeInputStyle() {
        return {
            'background': 'white',
            'color': '#2F384C',
            'font-size': '14px',
            'width': '210px',
            'position': 'relative',
            'right': '18px',
            'font-weight': '600'
        }
    }

    public get isInvalidIndustry() {
        return !this.company
        || !this.company.industry
        || !Array.isArray(this.industries)
        || !this.industries.find((ind) => ind.industry === this.company.industry)
    }

    public get selectedIndustry() {
        return this.company && this.company.industry
            ? this.company.industry
            : this.defaultIndustry.industry
    }

    public get message() {
        if (!this.industries || !Array.isArray(this.industries)) {
            return ''
        }
        const industry = this.industries.find((ind) => ind.industry === this.industry)

        if (industry && !industry.has_sufficient_data) {
            return 'Sorry, we don’t have enough data yet to provide benchmarking for your industry. We’re working on it!'
        }
        return ''
    }

    public toggleModal() {
        // load industries if it hasn't been loaded when displaying the modal
        if (!this.industriesLoaded || !this.industries || !this.industries.length) {
            this.loadBenchmarkIndustriesList()
            this.industriesLoaded = true
        }
    }

    public setDateRange({from, to}) {
        this.fromDate = moment(from, 'YYYY-MM-DD').toDate()
        this.toDate =  moment(to, 'YYYY-MM-DD').toDate()
    }

    public get industryOptions() {
        // append a `Please select industry` option if the industry has not been set or is invalid value
        if (this.isInvalidIndustry) {
            return [this.defaultIndustry, ...this.industries]
        }
        return this.industries
    }

    public onSelectIndustry(e) {
        let { value } = e.target
        if (value === this.defaultIndustry.industry) {
            value = ''
        }
        this.industry = value
        // update the company industry on Vuex
        this.setIndustry(this.industry)
    }

    private async downloadFile() {
        return getGeneralNPSReport({
            industry: this.industry,
            // eg.: `custom/01-11-2019_30-11-2019`
            daterange: 'custom/' + moment(this.fromDate).format('DD-MM-YYYY') + '_' + moment(this.toDate).format('DD-MM-YYYY')
        })
    }

    private async downloadFileAsync() {
        return getGeneralNPSReportAsync({
            industry: this.industry,
            // eg.: `custom/01-11-2019_30-11-2019`
            daterange: 'custom/' + moment(this.fromDate).format('DD-MM-YYYY') + '_' + moment(this.toDate).format('DD-MM-YYYY')
        })
    }

    private get fileName() {
        return (
            'AskNicely-Summary-Report-' +
            moment(this.toDate).format('YYYY-MM-DD') +
            '.pptx'
        )
    }
}
